import { FETCH_PRIVACY, GET_PRIVACY, CREATE_PRIVACY, UPDATE_PRIVACY, DELETE_PRIVACY } from 'actions/privacy';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  privacy: [],
  privacyDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const privacyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_PRIVACY.REQUEST:
    case GET_PRIVACY.REQUEST:
    case CREATE_PRIVACY.REQUEST:
    case DELETE_PRIVACY.REQUEST: {
      return { ...state, isLoading: true, privacyDetail: {} };
    }

    case UPDATE_PRIVACY.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_PRIVACY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        privacy: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_PRIVACY.SUCCESS: {
      return {
        ...state,
        privacyDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_PRIVACY.SUCCESS: {
      toast.success('Privacy added successfully');
      return {
        ...state,
        privacy: _.concat(state.privacy, payload),
        isLoading: false,
      };
    }

    case UPDATE_PRIVACY.SUCCESS: {
      toast.success('Privacy updated successfully');
      return {
        ...state,
        isLoading: false,
        privacy: state.privacy.map((data) => {
          if (data.id === payload.id) {
            return payload;
          } else {
            return data;
          }
        }),
      };
    }

    case DELETE_PRIVACY.SUCCESS: {
      toast.success('Privacy deleted successfully');
      return {
        ...state,
        privacy: state.privacy.filter((data) => data.id !== payload),
      };
    }

    case FETCH_PRIVACY.FAIL:
    case GET_PRIVACY.FAIL:
    case CREATE_PRIVACY.FAIL:
    case UPDATE_PRIVACY.FAIL:
    case DELETE_PRIVACY.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default privacyReducer;
